import { Injectable, Injector, NgModule } from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { of, ReplaySubject, throwError } from 'rxjs';
import { take, switchMap, catchError, filter, finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class AuthTokenManager {
    constructor() { }
    /**
     * Get token
     * @return {?}
     */
    getToken() {
        return this._token || null;
    }
    /**
     * Set token
     * @param {?} token
     * @return {?}
     */
    setToken(token) {
        this._token = token;
    }
    /**
     * Delete token
     * @return {?}
     */
    deleteToken() {
        this._token = null;
    }
}
AuthTokenManager.ɵfac = function AuthTokenManager_Factory(t) { return new (t || AuthTokenManager)(); };
AuthTokenManager.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthTokenManager, factory: AuthTokenManager.ɵfac });
/** @nocollapse */
AuthTokenManager.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthTokenManager, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class AuthConstants {
}
AuthConstants.BASE_PATH = '';
AuthConstants.ME_ENDPOINT = '/oauth/me';
AuthConstants.TOKEN_ENDPOINT = '/oauth/token';
AuthConstants.LOGIN_ENDPOINT = '/oauth/login';
AuthConstants.LOGOUT_ENDPOINT = '/oauth/logout';
AuthConstants.LOGOUT_WITH_ERROR_ENDPOINT = '/oauth/logout/error';
AuthConstants.TOKEN_RENEWAL_BUFFER = 60;
class AuthConfig {
    constructor() {
        this._basePath = AuthConstants.BASE_PATH;
        this._meUri = AuthConstants.ME_ENDPOINT;
        this._tokenUri = AuthConstants.TOKEN_ENDPOINT;
        this._loginUri = AuthConstants.LOGIN_ENDPOINT;
        this._logoutUri = AuthConstants.LOGOUT_ENDPOINT;
        this._logoutWithErrorUri = AuthConstants.LOGOUT_WITH_ERROR_ENDPOINT;
    }
    /**
     * @return {?}
     */
    get meUri() {
        return `${this._basePath}${this._meUri}`;
    }
    /**
     * @return {?}
     */
    get loginUri() {
        return `${this._basePath}${this._loginUri}`;
    }
    /**
     * @return {?}
     */
    get logoutUri() {
        return `${this._basePath}${this._logoutUri}`;
    }
    /**
     * @return {?}
     */
    get logoutWithErrorUri() {
        return `${this._basePath}${this._logoutWithErrorUri}`;
    }
    /**
     * @return {?}
     */
    get tokenUri() {
        return `${this._basePath}${this._tokenUri}`;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set basePath(value) {
        this._basePath = value;
    }
}
AuthConfig.ɵfac = function AuthConfig_Factory(t) { return new (t || AuthConfig)(); };
AuthConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthConfig, factory: AuthConfig.ɵfac });
/** @nocollapse */
AuthConfig.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthConfig, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class AuthService {
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @return {?}
     */
    getToken() {
        return this.http
            .get(this.config.meUri, { headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'If-Modified-Since': '0' } });
    }
    /**
     * @param {?=} multiFactor
     * @return {?}
     */
    redirectToLogin(multiFactor = false) {
        window.location.assign(`${this.config.loginUri}?multiFactor=${multiFactor}`);
    }
    /**
     * @return {?}
     */
    redirectToLogout() {
        window.location.assign(this.config.logoutUri);
    }
    /**
     * @return {?}
     */
    redirectToLogoutWithError() {
        window.location.assign(this.config.logoutWithErrorUri);
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(AuthConfig)); };
AuthService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
/** @nocollapse */
AuthService.ctorParameters = () => [
    { type: HttpClient },
    { type: AuthConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: AuthConfig }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Token {
    /**
     * @param {?} username
     * @param {?} exp
     * @param {?} multiFactor
     * @param {?=} refreshBuffer
     */
    constructor(username, exp, multiFactor, refreshBuffer = 60) {
        this.multiFactor = multiFactor;
        this.username = username;
        this.expires = new Date((exp - refreshBuffer) * 1000);
    }
    /**
     * Checks if current token is a valid token
     *
     * @param {?} token
     * @return {?}
     */
    static isValid(token) {
        if (!token) {
            return false;
        }
        return new Date() <= token.expires;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * An auth guard for protecting routes
 */
class AuthGuard {
    /**
     * @param {?} manager
     * @param {?} auth
     */
    constructor(manager, auth) {
        this.manager = manager;
        this.auth = auth;
    }
    /**
     * @return {?}
     */
    getFromStoreOrAPI() {
        /** @type {?} */
        const token = this.manager.getToken();
        if (Token.isValid(token)) {
            return of(true);
        }
        else {
            return this.auth.getToken()
                .pipe(take(1), switchMap((resp) => {
                this.manager.setToken(new Token(resp.username, resp.exp, resp.multiFactor));
                return of(true);
            }), catchError(() => {
                this.auth.redirectToLogin();
                return of(false);
            }));
        }
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        return this.getFromStoreOrAPI();
    }
    /**
     * @param {?} childRoute
     * @param {?} state
     * @return {?}
     */
    canActivateChild(childRoute, state) {
        return this.getFromStoreOrAPI();
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(AuthTokenManager), ɵngcc0.ɵɵinject(AuthService)); };
AuthGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac });
/** @nocollapse */
AuthGuard.ctorParameters = () => [
    { type: AuthTokenManager },
    { type: AuthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable
    }], function () { return [{ type: AuthTokenManager }, { type: AuthService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class AuthInterceptor {
    /**
     * @param {?} inj
     * @param {?} backend
     * @param {?} manager
     * @param {?} config
     */
    constructor(inj, backend, manager, config) {
        this.inj = inj;
        this.backend = backend;
        this.manager = manager;
        this.config = config;
        this.isRefreshingToken = false;
        this.tokenSubject = new ReplaySubject(1);
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    refreshApiToken(request, next) {
        /** @type {?} */
        const token = this.manager.getToken();
        if (token && !Token.isValid(token)) {
            if (this.isRefreshingToken) {
                return this.tokenSubject
                    .pipe(filter((t) => !!t), take(1), switchMap(t => {
                    this.manager.setToken(t);
                    return next.handle(request);
                }));
            }
            else {
                this.isRefreshingToken = true;
                // Reset here so that the following requests wait until the token
                // comes back from the refreshToken call.
                this.tokenSubject.next(null);
                return this.backend.handle(this.createRefreshTokenRequest())
                    .pipe(switchMap((event) => {
                    if (event instanceof HttpResponse) {
                        /** @type {?} */
                        const body = event.body;
                        this.tokenSubject.next(new Token(body.username, body.exp, body.multiFactor));
                    }
                    return next.handle(request);
                }), catchError(err => {
                    this.manager.deleteToken();
                    this.inj.get(AuthService).redirectToLogin();
                    return throwError(err);
                }), finalize(() => this.isRefreshingToken = false));
            }
        }
        else {
            return next.handle(request);
        }
    }
    /**
     * @return {?}
     */
    createRefreshTokenRequest() {
        /** @type {?} */
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        headers = headers.set('Accept', 'application/json');
        return new HttpRequest('POST', this.config.tokenUri, 'grant_type=refresh_token', {
            headers: headers
        });
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        return this.refreshApiToken(request, next);
    }
}
AuthInterceptor.ɵfac = function AuthInterceptor_Factory(t) { return new (t || AuthInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc1.HttpBackend), ɵngcc0.ɵɵinject(AuthTokenManager), ɵngcc0.ɵɵinject(AuthConfig)); };
AuthInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthInterceptor, factory: AuthInterceptor.ɵfac });
/** @nocollapse */
AuthInterceptor.ctorParameters = () => [
    { type: Injector },
    { type: HttpBackend },
    { type: AuthTokenManager },
    { type: AuthConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc1.HttpBackend }, { type: AuthTokenManager }, { type: AuthConfig }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class AuthModule {
}
AuthModule.ɵfac = function AuthModule_Factory(t) { return new (t || AuthModule)(); };
AuthModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [AuthService, AuthConfig, AuthTokenManager, AuthGuard], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                exports: [],
                imports: [
                    CommonModule
                ],
                entryComponents: [],
                providers: [AuthService, AuthConfig, AuthTokenManager, AuthGuard]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { imports: function () { return [CommonModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { AuthGuard, AuthInterceptor, AuthModule, AuthConfig, AuthService, AuthTokenManager, Token };

